import { render, staticRenderFns } from "./PendingBenefitApprovals.vue?vue&type=template&id=4b34e6a8&scoped=true&"
import script from "./PendingBenefitApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingBenefitApprovals.vue?vue&type=script&lang=js&"
import style0 from "./PendingBenefitApprovals.vue?vue&type=style&index=0&id=4b34e6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b34e6a8",
  null
  
)

export default component.exports